export const getTranslation = (translations, locale = "en") =>
  (translations || {})[locale] ||
  (translations || {})[
    Object.keys(translations || {})
      .sort()
      .find((k) => (translations || {})[k])
  ] ||
  "";
